import { useEffect, useState } from "react";
import { apiFetch } from "./config";

export default function AuthGate({ children, statut = "perso", auto = false, deniedMessage }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const login = () => {
    // Lu par le CAS pour revenir sur la page courante après connexion
    document.cookie =
      "RASCAS_FROM=" +
      encodeURIComponent(window.location.href) +
      "; domain=univ-angers.fr; path=/; max-age=604800; secure; samesite=lax";
    window.location.href = "https://cas.ras.univ-angers.fr/?login";
  };

  useEffect(() => {
    apiFetch("/auth/me")
      .then((r) => (r.ok ? r.json() : null))
      .then((u) => {
        setUser(u);
        // Une seule redirection auto par page, pour éviter une boucle si le JWT est refusé
        const cle = "rascas_auto_" + window.location.pathname;
        if (!u && auto && !sessionStorage.getItem(cle)) {
          sessionStorage.setItem(cle, "1");
          login();
          return;
        }
        if (u) sessionStorage.removeItem(cle);
        setLoading(false);
      })
      .catch(() => {
        setUser(null);
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return null;

  if (user && ![].concat(statut).includes(user.statut)) {
    return (
      <div style={{ textAlign: "center", marginTop: "20vh" }}>
        <h2>{typeof deniedMessage === "function" ? deniedMessage(user) : deniedMessage || "Accès réservé au personnel"}</h2>
      </div>
    );
  }
  

  if (!user) {
    return (
      <div style={{ textAlign: "center", marginTop: "20vh" }}>
        <h2>Émargement</h2>
        <button onClick={login}>Connexion</button>
      </div>
    );
  }

  return typeof children === "function" ? children(user) : children;
}
